import React from 'react';
import { BigBar, FullBar, MediumBar, SmallBar, TinyBar } from '../Forms';
import './styles.scss';

export function FeedItemSkeleton() {
  return (
    <div className="feed-item-skeleton pulse-fade">
      <div className="feed-item-skeleton__header">
        <div className="feed-item-skeleton__circle" />

        <div className="feed-item-skeleton__header-bars">
          <MediumBar />
          <SmallBar />
        </div>
      </div>

      <div className="feed-item-skeleton__content">
        <FullBar />
        <BigBar />
      </div>

      <div className="feed-item-skeleton__box" />

      <div className="feed-item-skeleton__footer">
        <TinyBar />
        <TinyBar />
        <TinyBar />
      </div>
    </div>
  );
}
